import { render } from "./courseContentEditor.vue?vue&type=template&id=87d3d2d2&ts=true"
import script from "./courseContentEditor.vue?vue&type=script&lang=ts"
export * from "./courseContentEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__